//jacques-andre-editeur\JAEfrontend\src\components\Header.jsx
import { Navbar, Nav, Container, 
  NavDropdown, 
  Badge } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import { FaShoppingCart, FaUser } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { useCreateSubscriberMutation } from '../slices/subscribersApiSlice';
import { useState } from 'react';
import { logout } from '../slices/authSlice';
import SearchBox from './SearchBox';
import logo from '../assets/logo.png';
import { resetCart } from '../slices/cartSlice';
import { Form, Button } from 'react-bootstrap';
import { FaPaperPlane } from "react-icons/fa";


const Header = () => {
  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(resetCart());
      navigate('/login');
    } catch (err) {
      console.error(err);
    }
  };

  const isAdminRoute = location.pathname.startsWith('/admin');

  const [email, setEmail] = useState('');
  const [createSubscriber, { isLoading, isSuccess, isError, error }] = useCreateSubscriberMutation();

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');





  return (
    <header>
      <Navbar bg='light' variant='light' expand='lg' collapseOnSelect className="navbar-white">
        <Container>
          <Navbar.Brand as={Link} to='/'>
            <img src={logo} alt='Jacques André Éditeur' />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav' className='flex-column'>
          {/* <Navbar.Collapse id='basic-navbar-nav' className='d-flex flex-column'> */}
            {isAdminRoute ? (
              // Navigation Admin
              <>
                {/* <Row className='w-100 g-0 mb-2 mb-lg-0'>
                    <SearchBox />
                </Row> */}
                <Row>
                  <div className='adminHeaderTitle'>Espace administrateur</div>
                </Row>
                <Nav className='d-flex justify-content-center w-100 mt-1'>
                    {/* <Nav.Link as={Link} to='/admin//alaune' className='nav-link px-3 onglet'>Accueil admin</Nav.Link> */}
                    <Nav.Link as={Link} to='/admin' className='nav-link px-3 onglet'>Accueil admin</Nav.Link>
                    <Nav.Link as={Link} to='/admin/booklist' className='nav-link px-3 onglet'>Livres</Nav.Link>
                    <Nav.Link as={Link} to='/admin/authorlist' className='nav-link px-3 onglet'>Auteurs</Nav.Link>
                    <Nav.Link as={Link} to='/admin/bookscollectionlist' className='nav-link px-3 onglet'>Collections</Nav.Link>
                    <Nav.Link as={Link} to='/admin/newslist' className='nav-link px-3 onglet'>Actualités</Nav.Link>
                    <Nav.Link as={Link} to='/admin/orderlist' className='nav-link px-3 onglet'>Commandes</Nav.Link>  
                    {userInfo ? (
                      <>
                      {/* <Nav.Link as={Link} to='/profile' className='nav-link px-3 onglet'>Profil</Nav.Link> */}
                      <Nav.Link onClick={logoutHandler} className='nav-link px-3 dernierOnglet'>Déconnexion</Nav.Link>
                      </>
                    ) : (
                      <Nav.Link as={Link} to='/login'>
                        <FaUser /> Connexion
                      </Nav.Link>
                    )}
                </Nav>
              </>
              
            ) : (
              // Navigation Public
              <>
                <Row className='w-100 g-0 mb-2 mb-lg-0'>
                  <Col xs={12} lg={8} className='pe-0 pe-lg-2'>
                    <SearchBox />
                  </Col>
                  <Col xs={12} lg={4}>
                    {/* <Form className='input-group mt-2 mt-lg-0 px-0' onSubmit={async (e) => {
                      e.preventDefault();
                      if (!email.trim()) return;

                      try {
                        await createSubscriber({ email }).unwrap();
                        setEmail('');
                        alert("Merci ! Vous êtes inscrit à la newsletter.");
                      } catch (err) {
                        console.error(err);
                        alert("Erreur lors de l'inscription.");
                      }
                    }}> */}<Form className='input-group mt-2 mt-lg-0 px-0' onSubmit={async (e) => {
  e.preventDefault();
  if (!email.trim()) return;

  const confirmation = window.confirm("Je suis d'accord pour recevoir les mails de la newsletter, dont je pourrai me désabonner à tout moment.");

  if (!confirmation) return;

  try {
    await createSubscriber({ email }).unwrap();
    setEmail('');
    alert("Merci ! Vous êtes inscrit à la newsletter.");
  } catch (err) {
    console.error(err);
    alert("Erreur lors de l'inscription.");
  }
}}>

                      <Form.Control
                        type='email'
                        className='form-control'
                        placeholder="S'inscrire à la newsletter"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      >        
                      </Form.Control>
                      <Button type='submit' variant='primary' className='btn btn-primary light'><FaPaperPlane /></Button>
                    </Form>











                  </Col>
                </Row>
                <Nav className='d-flex justify-content-center w-100 mt-1'>
                  <Nav className='d-flex justify-content-center w-100'>
                    <Nav.Link as={Link} to='/livres' className='nav-link px-3 onglet'>Livres</Nav.Link>
                    <Nav.Link as={Link} to='/auteurs' className='nav-link px-3 onglet'>Auteurs</Nav.Link>
                    <Nav.Link as={Link} to='/collections' className='nav-link px-3 onglet'>Collections</Nav.Link>
                    <Nav.Link as={Link} to='/actualites' className='nav-link px-3 onglet'>Actualités</Nav.Link>
                    <Nav.Link as={Link} to='/contacts' className='nav-link px-3 dernierOnglet'>Contact</Nav.Link>                
                  </Nav>
                  <Nav.Link as={Link} to='/panier' className='cart-link d-flex align-items-center'>
                    <FaShoppingCart className='cart-icon text-primary' />&nbsp;Panier
                    {cartItems.length > 0 && (
                      <Badge pill bg='success' style={{ marginLeft: '5px' }}>
                        {cartItems.reduce((a, c) => a + c.qty, 0)}
                      </Badge>
                    )}
                  </Nav.Link>
                </Nav>
              </>
            )}
            <Nav className='ms-auto'>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      


      {/* <Navbar bg='light' variant='light' expand='lg' collapseOnSelect>
        <Container>
          <Navbar.Brand as={Link} to='/'>
            <img src={logo} alt='Jacques André Éditeur' />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            {isAdminRoute ? (
              // Navigation Admin
              <>
                <Nav className='me-auto'>
                <Nav.Link as={Link} to='/admin/dashboard'>Dashboard</Nav.Link>
                <Nav.Link as={Link} to='/admin/booklist'>Produits</Nav.Link>
                <Nav.Link as={Link} to='/admin/orderlist'>Commandes</Nav.Link>
                <Nav.Link as={Link} to='/admin/userlist'>Utilisateurs</Nav.Link>
              </Nav>
              <NavDropdown title='Admin' id='adminmenu'>
                <NavDropdown.Item as={Link} to='/admin/booklist'>Books</NavDropdown.Item>
                <NavDropdown.Item as={Link} to='/admin/orderlist'>Orders</NavDropdown.Item>
                <NavDropdown.Item as={Link} to='/admin/userlist'>Users</NavDropdown.Item>
              </NavDropdown>
              {userInfo ? (
                <NavDropdown title={userInfo.name} id='username'>
                  <NavDropdown.Item as={Link} to='/profile'>Profile</NavDropdown.Item>
                  <NavDropdown.Item onClick={logoutHandler}>Déconnexion</NavDropdown.Item>
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to='/login'>
                  <FaUser /> Connexion
                </Nav.Link>
              )}</>
              
            ) : (
              // Navigation Public
              <>
                <Nav className='ms-auto'>
                  <Nav.Link as={Link} to='/livres'>Tous&nbsp;nos&nbsp;livres</Nav.Link>
                  <Nav.Link as={Link} to='/auteurs'>Auteurs</Nav.Link>
                  <Nav.Link as={Link} to='/collections'>Collections</Nav.Link>
                  <Nav.Link as={Link} to='/evenements'>Évènements</Nav.Link>
                  <Nav.Link as={Link} to='/contacts'>Contacts</Nav.Link>
                  <SearchBox />
                  <Nav.Link as={Link} to='/cart'>
                    <FaShoppingCart /> Panier
                    {cartItems.length > 0 && (
                      <Badge pill bg='success' style={{ marginLeft: '5px' }}>
                        {cartItems.reduce((a, c) => a + c.qty, 0)}
                      </Badge>
                    )}
                  </Nav.Link>
                </Nav>
              </>
            )}
            <Nav className='ms-auto'>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar> */}
    </header>
  );
};

export default Header;
